import { Button, Checkbox, Grid, Group, Loader, Stack, Text } from '@mantine/core';
import { useState } from 'react';

import { User } from '@e-origin/shared';

import { PasswordInput, TextInput } from '@components';
import { useEditUserFormInitializer } from './useEditUserFormInitializer';

interface EditUserProps {
  user?: User;
  currentUser?: User;
  onHide: () => void;
}

export const EditUser: React.FC<EditUserProps> = ({ user, currentUser, onHide }) => {
  const [formError, setFormError] = useState<string | null>(null);

  const { form, onSubmit, isSubmitting } = useEditUserFormInitializer({
    user,
  });

  const handleSubmit = async (values) => {
    setFormError(null);

    try {
      await onSubmit(values);
      onHide();
    } catch (error: any) {
      setFormError(error.message || 'Failed to save user');
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack gap="md" my="xl">
        {!!user && currentUser?._id !== user._id && (
          <Group>
            <Checkbox
              {...form.getInputProps('deleted', { type: 'checkbox' })}
              label="Active"
              checked={!form.values.deleted}
              onChange={(event) => form.setFieldValue('deleted', !event.currentTarget.checked)}
            />
            <Checkbox {...form.getInputProps('visible', { type: 'checkbox' })} label="Visible" checked={form.values.visible} />
          </Group>
        )}
        <TextInput {...form.getInputProps('email')} label="Email" placeholder="Email address" disabled={!!user} />

        <Grid>
          <Grid.Col span={6}>
            <TextInput {...form.getInputProps('firstName')} label="First Name" placeholder="Enter first name" />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput {...form.getInputProps('lastName')} label="Last Name" placeholder="Enter last name" />
          </Grid.Col>
        </Grid>

        {!user && <PasswordInput {...form.getInputProps('password')} label="Password" withAsterisk type="password" size="lg" />}
      </Stack>

      {formError && (
        <Text c="red" fw="bold" mt="md">
          {formError}
        </Text>
      )}

      <Group justify="center" mt="xl">
        <Button type="button" key="cancel-modal-btn" onClick={() => onHide()} disabled={isSubmitting} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button
          key="save-modal-btn"
          disabled={!form.isValid() || isSubmitting}
          type="submit"
          leftSection={isSubmitting && <Loader color="#FFFFFF" />}
          variant="filled"
          size="lg"
        >
          Save
        </Button>
      </Group>
    </form>
  );
};
